import {
  IceRepaymentType,
  AdvanceFilter,
  IceRowType,
  AdvanceSubtype,
} from "../helpers/constant";
export default {
  setLoanAdvanceType(payload, loanadescription) {
    let userEnteredData = [];
    for (let i = 0; i < payload.length; i++) {
      let amount = 0;
      let rowTypeId = this.getICERowType(
        payload[i].typeId,
        payload[i].subTypeId,
        payload[i].repaymentType
      );

      if (rowTypeId == IceRowType.LoanStructure) {
        amount = IceRepaymentType.Interest_Only;
      } else if (rowTypeId == IceRowType.LoanTerm) {
        amount =
          this.defaultIntValue(payload[i].adjustedTerm) * 12 +
          this.defaultIntValue(payload[i].amount);
      } else {
        amount = this.defaultIntValue(payload[i].amount);
      }
      if (rowTypeId == IceRowType.LoanRepayment_Principal_Interest) {
        let row = this.addICERow(
          IceRowType.LoanRepayment,
          payload[i],
          amount,
          loanadescription
        );
        userEnteredData.push(row);
      } else {
        let row = this.addICERow(
          rowTypeId,
          payload[i],
          amount,
          loanadescription
        );
        userEnteredData.push(row);
      }
    }

    return userEnteredData;
  },
  defaultStringValue(value) {
    if (!value) {
      return "";
    } else {
      return value;
    }
  },

  defaultIntValue(value) {
    if (!value || value == "" || isNaN(value)) {
      return 0;
    } else {
      return value;
    }
  },
  addICERow(TypeId, GridRow, Amount, loanadescription) {
    let row = {};
    row.Type = TypeId;
    row.Amount = Amount;
    row.END = this.defaultDateValue(GridRow.endDate);
    row.AccountNumber = "";
    row.EndType = this.defaultIntValue(GridRow.endDateType);
    row.Start = this.defaultDateValue(GridRow.startDate);
    row.StartType = this.defaultIntValue(GridRow.startDateType);
    row.Indexation = this.defaultIntValue(GridRow.index);
    row.Frequency = this.defaultIntValue(GridRow.frequency);
    row.EffectiveAsOn =
      TypeId == IceRowType.LoanRepayment ||
      TypeId == IceRowType.LoanRepayment_LumpSum ||
      TypeId == IceRowType.DrawDown_Reg
        ? 2
        : this.defaultIntValue(GridRow.effectiveAsON);
    row.Description = loanadescription;
    return row;
  },
  defaultDateValue(element) {
    if (!element || element == "") {
      return "";
    } else {
      let isDateAppend = element.split("/");
      if (isDateAppend.length > 2) {
        return element;
      }
      return "01/" + element;
    }
  },
  getICERowType(typeId, subTypeId, repaymentType) {
    if (
      typeId == AdvanceFilter.Interest_Rate &&
      subTypeId == AdvanceSubtype.Interest_Rate.InterestRate
    ) {
      return IceRowType.InterestRate;
    } else if (
      typeId == AdvanceFilter.Repayment &&
      subTypeId == AdvanceSubtype.Repayment.Regular &&
      repaymentType == AdvanceSubtype.Repayment.RegularType.Minimum_Repayment
    ) {
      return IceRowType.LoanRepayment;
    } else if (
      typeId == AdvanceFilter.Repayment &&
      subTypeId == AdvanceSubtype.Repayment.Regular &&
      repaymentType == AdvanceSubtype.Repayment.RegularType.InterestOnly
    ) {
      return IceRowType.LoanStructure;
    } else if (
      typeId == AdvanceFilter.Repayment &&
      subTypeId == AdvanceSubtype.Repayment.Regular &&
      repaymentType == AdvanceSubtype.Repayment.RegularType.PauseRepayment
    ) {
      return IceRowType.LoanRepayment_Pause;
    } else if (
      typeId == AdvanceFilter.Repayment &&
      subTypeId == AdvanceSubtype.Repayment.Regular &&
      repaymentType ==
        AdvanceSubtype.Repayment.RegularType.Principal_And_Interest
    ) {
      return IceRowType.LoanRepayment;
    } else if (
      typeId == AdvanceFilter.Repayment &&
      subTypeId == AdvanceSubtype.Repayment.LumpSum
    ) {
      return IceRowType.LoanRepayment_LumpSum;
    } else if (
      typeId == AdvanceFilter.DrawDown &&
      subTypeId == AdvanceSubtype.DrawDown.Reguar
    ) {
      return IceRowType.DrawDown_Reg;
    } else if (
      typeId == AdvanceFilter.DrawDown &&
      subTypeId == AdvanceSubtype.DrawDown.LumpSum
    ) {
      return IceRowType.DrawDown_LumpSum;
    } else if (
      typeId == AdvanceFilter.LoanTerm &&
      subTypeId == AdvanceSubtype.LoanTerm.LoanTerm
    ) {
      return IceRowType.LoanTerm;
    } else {
      return 0;
    }
  },
};
